import { AggregateDatadogLogger } from './AggregateDatadogLogger';

const logger = new AggregateDatadogLogger();

export function datadog() {
  return logger;
}
